import { Routes } from '@angular/router';
import { permissionGuard } from './guards/permission.guard';


export const routes: Routes = [
  // Home route - shows the main page with all sections
  { path: '', loadComponent: () => import('./components/home/home.component').then(m => m.HomeComponent) },
  
  // News routes
  { path: 'news', loadComponent: () => import('./components/news/news.component').then(m => m.NewsComponent) },
  { path: 'news/:id', loadComponent: () => import('./components/news/news-detail/news-detail.component').then(m => m.NewsDetailComponent) },
  
  // Events routes
  { path: 'events', loadComponent: () => import('./components/events/events.component').then(m => m.EventsComponent) },
  { path: 'events/:id', loadComponent: () => import('./components/events/event-detail/event-detail.component').then(m => m.EventDetailComponent) },
  
  // Galleries route
  { path: 'galleries', loadComponent: () => import('./components/galleries/galleries.component').then(m => m.GalleriesComponent) },
  
  // Public Transparency route
  { path: 'transparency', loadComponent: () => import('./components/transparency/public-transparency.component').then(m => m.PublicTransparencyComponent) },

  
  // Admin routes (protected dynamically by PermissionGuard)
  { 
    path: 'admin/dashboard', 
    loadComponent: () => import('./components/admin/dashboard/dashboard.component').then(m => m.DashboardComponent),
    canActivate: [permissionGuard],
    data: { permission: 'dashboard.read' }
  },
  { 
    path: 'admin/activity', 
    loadComponent: () => import('./components/admin/activity-log/activity-log.component').then(m => m.ActivityLogComponent),
    canActivate: [permissionGuard],
    data: { permission: 'dashboard.read' }
  },
  { 
    path: 'admin/gallery', 
    loadComponent: () => import('./components/admin/image-gallery/image-gallery.component').then(m => m.ImageGalleryComponent),
    canActivate: [permissionGuard],
    data: { permission: 'gallery.read' }
  },
  { 
    path: 'admin/news', 
    loadComponent: () => import('./components/admin/news-list/news-list.component').then(m => m.NewsListComponent),
    canActivate: [permissionGuard],
    data: { permission: 'news.read' }
  },
  { 
    path: 'admin/news/new', 
    loadComponent: () => import('./components/admin/news-form/news-form.component').then(m => m.NewsFormComponent),
    canActivate: [permissionGuard],
    data: { permission: 'news.create' }
  },
  { 
    path: 'admin/news/edit/:id', 
    loadComponent: () => import('./components/admin/news-form/news-form.component').then(m => m.NewsFormComponent),
    canActivate: [permissionGuard],
    data: { permission: 'news.update' }
  },
  
  // Comunicados / Alertas routes
  { 
    path: 'admin/comunicados', 
    loadComponent: () => import('./components/admin/comunicados-list/comunicados-list.component').then(m => m.ComunicadosListComponent),
    canActivate: [permissionGuard],
    data: { permission: 'comunicados.read' }
  },
  { 
    path: 'admin/comunicados/new', 
    loadComponent: () => import('./components/admin/comunicados-form/comunicados-form.component').then(m => m.ComunicadosFormComponent),
    canActivate: [permissionGuard],
    data: { permission: 'comunicados.create' }
  },
  { 
    path: 'admin/inbox', 
    loadComponent: () => import('./components/admin/comunicados-inbox/comunicados-inbox.component').then(m => m.ComunicadosInboxComponent),
    canActivate: [permissionGuard],
    data: { permission: 'dashboard.read' }
  },
  
  // Standalone Galleries
  { 
    path: 'admin/galleries', 
    loadComponent: () => import('./components/admin/standalone-gallery-list/standalone-gallery-list.component').then(m => m.StandaloneGalleryListComponent),
    canActivate: [permissionGuard],
    data: { permission: 'gallery.read' }
  },
  { 
    path: 'admin/galleries/new', 
    loadComponent: () => import('./components/admin/standalone-gallery-form/standalone-gallery-form.component').then(m => m.StandaloneGalleryFormComponent),
    canActivate: [permissionGuard],
    data: { permission: 'gallery.create' }
  },
  { 
    path: 'admin/galleries/edit/:id', 
    loadComponent: () => import('./components/admin/standalone-gallery-form/standalone-gallery-form.component').then(m => m.StandaloneGalleryFormComponent),
    canActivate: [permissionGuard],
    data: { permission: 'gallery.update' }
  },
  
  { 
    path: 'admin/events', 
    loadComponent: () => import('./components/admin/event-list/event-list.component').then(m => m.EventListComponent),
    canActivate: [permissionGuard],
    data: { permission: 'events.read' }
  },
  { 
    path: 'admin/events/new', 
    loadComponent: () => import('./components/admin/event-form/event-form.component').then(m => m.EventFormComponent),
    canActivate: [permissionGuard],
    data: { permission: 'events.create' }
  },
  { 
    path: 'admin/events/edit/:id', 
    loadComponent: () => import('./components/admin/event-form/event-form.component').then(m => m.EventFormComponent),
    canActivate: [permissionGuard],
    data: { permission: 'events.update' }
  },
 
  // Carousel routes
  { 
    path: 'admin/carousel', 
    loadComponent: () => import('./components/admin/carousel-list/carousel-list.component').then(m => m.CarouselListComponent),
    canActivate: [permissionGuard],
    data: { permission: 'carousel.read' }
  },
  { 
    path: 'admin/carousel/new', 
    loadComponent: () => import('./components/admin/carousel-form/carousel-form.component').then(m => m.CarouselFormComponent),
    canActivate: [permissionGuard],
    data: { permission: 'carousel.create' }
  },
  { 
    path: 'admin/carousel/edit/:id', 
    loadComponent: () => import('./components/admin/carousel-form/carousel-form.component').then(m => m.CarouselFormComponent),
    canActivate: [permissionGuard],
    data: { permission: 'carousel.update' }
  },
 
  // Banner routes
  { 
    path: 'admin/banner', 
    loadComponent: () => import('./components/admin/banner-list/banner-list.component').then(m => m.BannerListComponent),
    canActivate: [permissionGuard],
    data: { permission: 'banner.read' }
  },
  { 
    path: 'admin/banner/new', 
    loadComponent: () => import('./components/admin/banner-form/banner-form.component').then(m => m.BannerFormComponent),
    canActivate: [permissionGuard],
    data: { permission: 'banner.create' }
  },
  { 
    path: 'admin/banner/edit/:id', 
    loadComponent: () => import('./components/admin/banner-form/banner-form.component').then(m => m.BannerFormComponent),
    canActivate: [permissionGuard],
    data: { permission: 'banner.update' }
  },
 
  // Service routes
  { 
    path: 'admin/service', 
    loadComponent: () => import('./components/admin/service-list/service-list.component').then(m => m.ServiceListComponent),
    canActivate: [permissionGuard],
    data: { permission: 'services.read' }
  },
  { 
    path: 'admin/service/new', 
    loadComponent: () => import('./components/admin/service-form/service-form.component').then(m => m.ServiceFormComponent),
    canActivate: [permissionGuard],
    data: { permission: 'services.create' }
  },
  { 
    path: 'admin/service/edit/:id', 
    loadComponent: () => import('./components/admin/service-form/service-form.component').then(m => m.ServiceFormComponent),
    canActivate: [permissionGuard],
    data: { permission: 'services.update' }
  },
 
  // About & Contact routes
  { 
    path: 'admin/about', 
    loadComponent: () => import('./components/admin/about-form/about-form.component').then(m => m.AboutFormComponent),
    canActivate: [permissionGuard],
    data: { permission: 'about.read' }
  },
  { 
    path: 'admin/contact', 
    loadComponent: () => import('./components/admin/contact-form/contact-form.component').then(m => m.ContactFormComponent),
    canActivate: [permissionGuard],
    data: { permission: 'contact.read' }
  },
  { 
    path: 'admin/external-apps', 
    loadComponent: () => import('./components/admin/external-apps/external-apps.component').then(m => m.ExternalAppsComponent),
    canActivate: [permissionGuard],
    data: { permission: 'external_apps.read' }
  },
  { 
    path: 'admin/transparency', 
    loadComponent: () => import('./components/admin/transparency/transparency.component').then(m => m.TransparencyComponent),
    canActivate: [permissionGuard],
    data: { permission: 'transparency.read' }
  },
  { 
    path: 'admin/document-center', 
    loadComponent: () => import('./components/admin/document-center/document-center.component').then(m => m.DocumentCenterComponent),
    canActivate: [permissionGuard],
    data: { permission: 'document_center.read' }
  },
  {
    path: 'admin/chat',
    loadComponent: () => import('./components/chat/chat-shell.component').then(m => m.ChatShellComponent),
    canActivate: [permissionGuard],
    data: { permission: 'chat.read' }
  },
  {
    path: 'admin/workstation/:workstationId',
    loadComponent: () => import('./components/chat-wrapper/chat-wrapper.component').then(m => m.ChatWrapperComponent),
    canActivate: [permissionGuard],
    data: { permission: 'chat.read' }
  },
  // Personalización (memoria, tono, plantillas) de un agente puntual — propio o institucional.
  // Reutilizada tanto desde "Mis Agentes" como desde el selector de Chat Libre.
  {
    path: 'admin/personalizar/:agentId',
    loadComponent: () => import('./components/agent-personalize/agent-personalize.component').then(m => m.AgentPersonalizeComponent),
    canActivate: [permissionGuard],
    data: { permission: 'chat.read' }
  },
  // Literal sub-path (nuevo) must come before the :agentId param route below — the router
  // matches array order, not specificity, so a later literal route would otherwise never be
  // reached (":agentId" would swallow "nuevo" as an agent id first).
  {
    path: 'admin/mis-agentes/nuevo',
    loadComponent: () => import('./components/my-agents/my-agents.component').then(m => m.MyAgentsComponent),
    canActivate: [permissionGuard],
    data: { permission: 'agent.create.own' }
  },
  {
    path: 'admin/mis-agentes/:agentId',
    loadComponent: () => import('./components/my-agents/my-agents.component').then(m => m.MyAgentsComponent),
    canActivate: [permissionGuard],
    data: { permission: 'agent.create.own' }
  },
  {
    path: 'admin/mis-agentes',
    loadComponent: () => import('./components/my-agents/my-agents.component').then(m => m.MyAgentsComponent),
    canActivate: [permissionGuard],
    data: { permission: 'agent.create.own' }
  },
  // ─── Administración IA (Angular nativo) ─────────────────────────────────────
  // Literal sub-path ('nuevo') must come before the ':id' param route below — same reasoning
  // as 'admin/mis-agentes/nuevo' above: otherwise the router swallows "nuevo" as the id first.
  {
    path: 'admin/ai/agents/nuevo',
    loadComponent: () => import('./components/admin/ai-agents/ai-agents.component').then(m => m.AiAgentsComponent),
    canActivate: [permissionGuard],
    data: { permission: 'chat.quota.manage' }
  },
  {
    path: 'admin/ai/agents/:agentId',
    loadComponent: () => import('./components/admin/ai-agents/ai-agents.component').then(m => m.AiAgentsComponent),
    canActivate: [permissionGuard],
    data: { permission: 'chat.quota.manage' }
  },
  {
    path: 'admin/ai/agents',
    loadComponent: () => import('./components/admin/ai-agents/ai-agents.component').then(m => m.AiAgentsComponent),
    canActivate: [permissionGuard],
    data: { permission: 'chat.quota.manage' }
  },
  {
    path: 'admin/ai/kbases/nuevo',
    loadComponent: () => import('./components/admin/ai-kbases/ai-kbases.component').then(m => m.AiKbasesComponent),
    canActivate: [permissionGuard],
    data: { permission: 'chat.quota.manage' }
  },
  {
    path: 'admin/ai/kbases/:kbId',
    loadComponent: () => import('./components/admin/ai-kbases/ai-kbases.component').then(m => m.AiKbasesComponent),
    canActivate: [permissionGuard],
    data: { permission: 'chat.quota.manage' }
  },
  {
    path: 'admin/ai/kbases',
    loadComponent: () => import('./components/admin/ai-kbases/ai-kbases.component').then(m => m.AiKbasesComponent),
    canActivate: [permissionGuard],
    data: { permission: 'chat.quota.manage' }
  },
  {
    path: 'admin/ai/mcp-servers/nuevo',
    loadComponent: () => import('./components/admin/ai-mcp-servers/ai-mcp-servers.component').then(m => m.AiMcpServersComponent),
    canActivate: [permissionGuard],
    data: { permission: 'chat.quota.manage' }
  },
  {
    path: 'admin/ai/mcp-servers/:serverId',
    loadComponent: () => import('./components/admin/ai-mcp-servers/ai-mcp-servers.component').then(m => m.AiMcpServersComponent),
    canActivate: [permissionGuard],
    data: { permission: 'chat.quota.manage' }
  },
  {
    path: 'admin/ai/mcp-servers',
    loadComponent: () => import('./components/admin/ai-mcp-servers/ai-mcp-servers.component').then(m => m.AiMcpServersComponent),
    canActivate: [permissionGuard],
    data: { permission: 'chat.quota.manage' }
  },
  { 
    path: 'admin/chat-quotas', 
    loadComponent: () => import('./components/admin/chat-quota-management/chat-quota-management.component').then(m => m.ChatQuotaManagementComponent),
    canActivate: [permissionGuard],
    data: { permission: 'chat.quota.manage' }
  },
  {
    path: 'admin/chat-metrics',
    loadComponent: () => import('./components/admin/chat-metrics/chat-metrics.component').then(m => m.ChatMetricsDashboardComponent),
    canActivate: [permissionGuard],
    data: { permission: 'chat.quota.manage' }
  },
  {
    path: 'admin/invierte-dashboard',
    loadComponent: () => import('./components/admin/invierte-dashboard/invierte-dashboard-shell.component').then(m => m.InvierteDashboardShellComponent),
    canActivate: [permissionGuard],
    canActivateChild: [permissionGuard], // re-valida el permiso al entrar directo a una sub-ruta (bookmark/F5)
    data: { permission: 'invierte_dashboard.view' },
    children: [
      { path: '', redirectTo: 'postulaciones', pathMatch: 'full' },
      {
        path: 'postulaciones',
        loadComponent: () => import('./components/admin/invierte-dashboard/postulaciones-tab/postulaciones-tab.component').then(m => m.PostulacionesTabComponent),
      },
      {
        path: 'beneficiarios',
        loadComponent: () => import('./components/admin/invierte-dashboard/beneficiarios-tab/beneficiarios-tab.component').then(m => m.BeneficiariosTabComponent),
      },
      {
        path: 'detalle',
        loadComponent: () => import('./components/admin/invierte-dashboard/detalle-tab/detalle-tab.component').then(m => m.DetalleTabComponent),
      },
      {
        // URL real y compartible para un caso puntual (en vez de query param) — también
        // evita el problema de Angular reusando la instancia del componente entre
        // navegaciones a la misma ruta con solo el query param distinto.
        path: 'detalle/:instanceId',
        loadComponent: () => import('./components/admin/invierte-dashboard/detalle-tab/detalle-tab.component').then(m => m.DetalleTabComponent),
      },
      {
        path: 'flujo',
        loadComponent: () => import('./components/admin/invierte-dashboard/flujo-tab/flujo-tab.component').then(m => m.FlujoTabComponent),
      },
    ],
  },
  { 
    path: 'admin/rrhh', 
    loadComponent: () => import('./components/hr-wrapper/hr-wrapper.component').then(m => m.HRWrapperComponent),
    canActivate: [permissionGuard],
    data: { permission: 'rrhh.read' }
  },
  { 
    path: 'admin/users', 
    loadComponent: () => import('./components/user-management/user-management.component').then(m => m.UserManagementComponent),
    canActivate: [permissionGuard],
    data: { permission: 'security.read' }
  },
  { 
    path: 'admin/groups', 
    loadComponent: () => import('./components/user-management/group-list/group-list.component').then(m => m.GroupListComponent),
    canActivate: [permissionGuard],
    data: { permission: 'security.read' }
  },
  { 
    path: 'admin/roles', 
    loadComponent: () => import('./components/user-management/role-list/role-list.component').then(m => m.RoleListComponent),
    canActivate: [permissionGuard],
    data: { permission: 'security.read' }
  },
  { 
    path: 'admin/permissions', 
    loadComponent: () => import('./components/user-management/permissions-matrix/permissions-matrix.component').then(m => m.PermissionsMatrixComponent),
    canActivate: [permissionGuard],
    data: { permission: 'security.read' }
  },
  
  // Auth error routes
  { path: 'unauthorized', loadComponent: () => import('./components/auth/unauthorized/unauthorized.component').then(m => m.UnauthorizedComponent) },
  { path: 'login-failed', loadComponent: () => import('./components/auth/login-failed/login-failed.component').then(m => m.LoginFailedComponent) },
  
  // Wildcard route - must be last
  { path: '**', redirectTo: '' }
];